import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { downloadDocumentInBrowser } from '@/src/components/project/Files/Helpers/Helpers';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { FileEntry } from '@/src/components/project/Inbox2/types';

import { useLogActivity } from '../../../../../../api/logActivity';
import { useFileEntryViewerSidebarActions } from '../../../store/fileEntryViewer.sidebarActions.store';

type DownloadFileProps = {
  fileEntry: FileEntry;
};

const page = 'Inbox';

const DownloadFile = ({ fileEntry }: DownloadFileProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const { onFileUrlDownloaded } = sidebarActions;
  const logActivityMutation = useLogActivity();

  const handleClick = async () => {
    const data = [
      {
        linkId: fileEntry.file.id,
        linkType: 'document',
        title: `download a ${fileEntry.file.rawName}`,
        actionType: 'download',
        old: '',
        new: fileEntry.file.rawName,
        projectId,
        activity: `Downloaded a file ${page ? 'from ' + page : ''}`,
      },
    ];

    downloadDocumentInBrowser(fileEntry.file.rawName, fileEntry.file.name);

    await logActivityMutation.mutateAsync({
      data,
      type: 'file',
    });

    onFileUrlDownloaded();
  };

  return (
    <ActionButton
      id={'download_file'}
      className={clsx('tw-min-w-[25px]', 'tw-justify-center')}
      onClick={handleClick}
      tooltipSettings={{
        content: 'Download',
        place: 'left',
      }}
      icon={ICONS.download_icon({ fillClassName: 'group-hover:tw-fill-cfo-blue-600' })}
    />
  );
};

export default DownloadFile;
